import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "cross--circle",
  "use": "cross--circle-usage",
  "viewBox": "0 0 18.763 18.768",
  "content": "<symbol viewBox=\"0 0 18.763 18.768\" id=\"cross--circle\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M9.363 18.768c2.4 0 4.8-.924 6.65-2.747a9.305 9.305 0 0 0 2.75-6.643 9.35 9.35 0 0 0-2.75-6.644c-3.65-3.646-9.625-3.646-13.275 0-3.65 3.647-3.65 9.615 0 13.262a9.28 9.28 0 0 0 6.625 2.772M4.138 4.158c2.875-2.873 7.575-2.873 10.45 0a7.327 7.327 0 0 1 2.175 5.22 7.326 7.326 0 0 1-2.175 5.219c-2.875 2.873-7.575 2.873-10.45 0-2.875-2.872-2.875-7.567 0-10.439m8.518 6.652a1.154 1.154 0 1 1-1.632 1.634L9.5 10.921l-1.528 1.528a1.155 1.155 0 1 1-1.633-1.633l1.528-1.529-1.528-1.528a1.153 1.153 0 0 1 0-1.633 1.15 1.15 0 0 1 1.633 0L9.5 7.653l1.524-1.522a1.155 1.155 0 0 1 1.632 1.633l-1.522 1.524 1.522 1.522z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./application/components/dumb/icon/src/cross--circle.svg
// module id = 156
// module chunks = 0